import { render, staticRenderFns } from "./UpdateChannel.vue?vue&type=template&id=a2351af6&scoped=true&"
import script from "./UpdateChannel.vue?vue&type=script&lang=js&"
export * from "./UpdateChannel.vue?vue&type=script&lang=js&"
import style0 from "./UpdateChannel.vue?vue&type=style&index=0&id=a2351af6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2351af6",
  null
  
)

export default component.exports